<template>
  <div class="DRecommendHot">

    <div class="swiper-box">

      <i
        @click.stop="toggleSwiper(swiperOption.initialSlide-1)"
        class="iconfont icon-a-arrowrightbold icon-a-arrowrightbold2"></i>

      <i
        @click.stop="toggleSwiper(swiperOption.initialSlide+1)"
        class="iconfont icon-a-arrowrightbold"></i>


      <div
        v-swiper:mySwiper="swiperOption"
        class="swiper" >
        <div class="swiper-wrapper">
          <div
            v-for="(vo,idx) in hotList"
            :key="idx"
            class="swiper-slide _pointer"
          >
            <a
              :href="vo.link_url"
              target="_blank"
              :title="vo.title"
            >
              <img
                :src="PAGE_PATH.BASE_IMG_URL + '/' + vo.proto_pic"
                class="swiper-img">
            </a>
          </div>
        </div>

<!--        <div class="swiper-button-prev" slot="button-prev"
             @click.stop="toggleSwiper(swiperOption.initialSlide-1)"
        ></div>
        <div class="swiper-button-next" slot="button-next"
             @click.stop="toggleSwiper(swiperOption.initialSlide+1)"
        ></div>-->







      </div>



      <div class="pagination-custom">

        <i
          class="icon-arrow"
          @click.stop="toggleSwiper(swiperOption.initialSlide-1)"
        />
        <div class="bullet-wrap">
<!--          <div
            v-for="(vo,idx) in hotList"
            :key="idx"
            class="swiper-pagination-bullet"
            :class="{ 'swiper-pagination-bullet-active' : idx == swiperOption.initialSlide }"
            @mouseover.stop="toggleSwiper(idx)"
            @click.stop="toggleSwiper(idx)"
          >

          </div>-->
          {{ swiperOption.initialSlide+1 }} / {{ hotList.length }}
        </div>
        <i
          class="icon-arrow icon-arrow2"
          @click.stop="toggleSwiper(swiperOption.initialSlide+1)" />
      </div>
    </div>

  </div>
</template>

<script>
import DListTitle from '@/components/3d/d-list/d-list-title'
import { PAGE_PATH } from '@/constant/PAGE_PATH'
export default {
  name: "DRecommendHot",
  components:{
    DListTitle
  },
  props:{
    hotList:{
      type: Array,
      default:()=>[
        {
          label:1
        }
      ]
    }
  },
  data(){
    return{
      isShow: false,
      swiperOption: {
        autoplay: {
          delay: 5000,
          speed: 500,
          disableOninteraction: true
        },
        //配置分页
        prevButton: ".swiper-button-prev",
        nextButton: ".swiper-button-next",
        pagination: {
          // el: '.swiper-pagination'//分页的dom节点
        },
        direction: "horizontal",
        initialSlide: 0, // 默认选中
        loop: true, // 在此无效？？？？？
        centeredSlides: true, //活动块居中
        slideToClickedSlide: false, // 点击切换
        lazy: true,
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,//修改swiper的父元素时，自动初始化swiper
        on: {
          slideChange: () => {
            const c_swiper = document.getElementsByClassName("swiper");
            this.swiperOption.initialSlide = c_swiper[0].swiper.activeIndex -1;
            // this.swiperOption.initialSlide = c_swiper[0].swiper.activeIndex - 1;
            // console.log("轮播图滚动事件 --->",c_swiper[0].swiper.activeIndex)
            if (c_swiper[0].swiper.activeIndex - 1 >  this.hotList.length-1){
              this.swiperOption.initialSlide = 0
            }
            if (c_swiper[0].swiper.activeIndex - 1 <  0){
              this.swiperOption.initialSlide = this.hotList.length-1
            }
          }
        }
      },
      PAGE_PATH
    }
  },
  methods:{
    toggleSwiper(index) {
      console.log(index)
      // this.calendarMenuIndex = index;

      if (index > this.hotList.length-1){
        index = 0
      }
      if (index < 0){
        index = this.hotList.length-1;
      }
      this.swiperOption.initialSlide = index;
      if (process.client) {
        this.mySwiper.slideTo(index+1 , 500);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.swiper-box{
  width: 660px;
  height: 864px;
  position: relative;

  /*&:after{
    content: '';
    display: inline-block;
    //width: 100%;
    //height: 100%;
    width: 538px;
    height: 362px;
    @include Position(1,5,0,0);
    z-index: 10;
    pointer-events: none;
  }*/

  .swiper{
    width: 100%;
    height: 100%;
    border-radius: 14px;
    overflow: hidden;
    .swiper-img{
      width: 100%;
      height: 100%;
    }

  }

  .pagination-custom{
    @include Position(1,5,50%,16px);
    transform: translateX(-50%);
    z-index: 11;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 127px;
    height: 36px;
    background: rgba(0, 0, 0,0.35);
    box-shadow: 0px 2px 4px 0px rgba(10,37,64,0.1);
    border-radius: 20px;
    color: #FFFFFF;
    .icon-arrow{
      //@include BgImage(18px,18px,'3d/icon_arrow.png?v=2');
      border: 7px solid transparent;
      border-right: 7px solid #FFFFFF;
      border-radius: 2px;
      cursor: pointer;
      @include ElementHover('',''){
        border-right: 7px solid rgb(105, 105, 255);
      };

      &.icon-arrow2{
        transform: rotate(180deg);
      }

    }
    .bullet-wrap{
      width: 82px;
      display: flex;
      align-items: center;
      justify-content: center;
      .swiper-pagination-bullet{
        width: 6px;
        height: 6px;
        background: #ccc;
        margin-right: 4px;
        &:last-child{
          margin-right: 0;
        }
        &.swiper-pagination-bullet-active{
          background: rgb(105, 105, 255);
        }
      }
    }

  }

}

.icon-a-arrowrightbold {
  width: 36px;
  height: 36px;
  background: #FFFFFF;
  box-shadow: 0px 2px 4px 0px rgba(10, 37, 64, 0.1000);
  @include Position(1, 2, -18px, 50%);
  transform: translateY(-50%);
  border-radius: 50%;
  font-size: 20px;
  line-height: 36px;
  text-align: center;
  z-index: 2;

  @include ElementHover(#FFFFFF, $color-primary);

  &.icon-a-arrowrightbold2 {
    @include Position(1, 4, -18px, 50%);
    transform: translateY(-50%) rotate(180deg);
  }
}
</style>
